import { ApiRequestError } from "./api";

export interface DeviceAuthFailure {
  loginRequired: boolean;
  message: string;
}

export interface DeviceLoginAction {
  href: string;
  label: string;
}

export type BomanaLauncherMode = "popup" | "redirect" | null;

export function normalizeDeviceCode(code: string): string {
  return code.trim().toUpperCase();
}

export function buildDeviceLoginHref(code: string, launcherMode: BomanaLauncherMode = null): string {
  const parameters = new URLSearchParams({ user_code: normalizeDeviceCode(code) });
  if (launcherMode) parameters.set("launcher", "bomana");
  if (launcherMode === "redirect") parameters.set("return_mode", "redirect");
  const returnPath = `/device?${parameters.toString()}`;
  return `/?returnTo=${encodeURIComponent(returnPath)}`;
}

export function buildDeviceLoginAction(code: string, launcherMode: BomanaLauncherMode = null): DeviceLoginAction {
  return {
    href: buildDeviceLoginHref(code, launcherMode),
    label: "去登录",
  };
}

export function readBomanaLauncherMode(search: string): BomanaLauncherMode {
  const parameters = new URLSearchParams(search);
  if (parameters.get("launcher") !== "bomana") return null;
  const returnMode = parameters.get("return_mode");
  if (returnMode === null) return "popup";
  return returnMode === "redirect" ? "redirect" : null;
}

export function completeBomanaLauncherAuthorization(
  search: string,
  code: string,
  target: {
    readonly opener: { postMessage(message: unknown, targetOrigin: string): void } | null;
    close(): void;
    replace(url: string): void;
  },
): Exclude<BomanaLauncherMode, null> | null {
  const mode = readBomanaLauncherMode(search);
  if (mode === "popup" && target.opener) {
    target.opener.postMessage({
      type: "cheemspay:device-authorization-complete",
      userCode: normalizeDeviceCode(code),
    }, "https://bomana.ruikang.wang");
    target.close();
    return "popup";
  }
  if (mode === "redirect") {
    target.replace("https://bomana.ruikang.wang/launcher/?authorization=complete");
    return "redirect";
  }
  return null;
}

export function describeDeviceAuthFailure(error: unknown): DeviceAuthFailure {
  if (error instanceof ApiRequestError && error.status === 401) {
    return {
      loginRequired: true,
      message: "请先登录或重新登录，再批准该设备。",
    };
  }
  return {
    loginRequired: false,
    message: error instanceof Error ? error.message : "操作失败",
  };
}
